import component from "./ProfileGrades.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileGrades"

export default wrapVueComponent(componentName, component)
